import React, { useState, useRef, useEffect } from "react";
import "./index.scss";
import * as _ from "lodash";
import { useTranslation } from "react-i18next";

const Dropdown = ({ config }) => {
  const { t } = useTranslation();
  const options = _.get(config, "options", []);

  const onSelect = _.get(config, "onSelect");
  const placeholder = _.get(config, "placeholder", "");
  const style = _.get(config, "style", {});
  const stylePopup = _.get(config, "stylePopup", {});
  const className = _.get(config, "className", "");
  const map = _.get(config, "map", {
    id: "id",
    name: "name",
  });
  const value = _.get(config, "value", null);
  const [isOpen, setIsOpen] = useState(false);

  const [selected, setSelected] = useState(
    _.find(options, (option) => option[map.id] === value),
  );

  useEffect(() => {
    setSelected(_.find(options, (option) => option[map.id] === value));
  }, [value, options, map]);

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    setSelected(option);
    setIsOpen(false);
    if (onSelect) onSelect(option);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    setSelected(null);
    if (onSelect) onSelect(null);
  };

  return (
    <div
      ref={dropdownRef}
      style={{
        position: "relative",
        width: "max-content",
        minWidth: "200px",
        ...style,
      }}
    >
      <button
        className={`dropdown-button ${className}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{t(selected ? selected[map.name] : placeholder)}</span>
        {selected ? (
          <span className="clear-btn" onClick={handleClear} role="button">
            ×
          </span>
        ) : (
          <span>▼</span>
        )}
      </button>
      {isOpen && (
        <ul
          className="dropdown-ul"
          style={{
            height: "auto",
            overflow: "auto",
            overflowY: "scroll",
            ...stylePopup,
          }}
        >
          {options.map((option, index) => (
            <li
              key={index}
              onClick={() => handleSelect(option)}
              className="dropdown-li"
            >
              {t(option[map.name])}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
